import { render } from "./noData.vue?vue&type=template&id=0b18b490&scoped=true&ts=true"
import script from "./noData.vue?vue&type=script&lang=ts"
export * from "./noData.vue?vue&type=script&lang=ts"

import "./noData.vue?vue&type=style&index=0&id=0b18b490&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b18b490"]])

export default __exports__